<template>
    <!-- Componente para mostrar el formulario de cotización para BBVA y descargar la tabla de amortización -->
    <section id="bbva-form" class="quotation px-4 max-w-screen-lg xl:max-w-screen-xl mx-auto mb-20">
        <button
            v-show="!showLoader"
            class="flex items-center space-x-1 sm:space-x-2 hover:opacity-75"
            @click="$emit('back-to-simulator')"
        >
            <span class="text-light-blue">
                <i class="fa-solid fa-chevron-left fa-lg"></i>
            </span>
            <span class="inline-block text-sm sm:text-base">Regresar al simulador de crédito</span>
        </button>
        <div v-show="showIframe">
            <iframe
                v-if="appEnv === 'production'"
                class="iframe-cetelem"
                :src="`https://hyundaimotormex-leads.com/${
                    isIframe ? 'f1' : 'f2'
                }/cotizacion_bbva/?dealer_code=${subsidiary}&modelo=${modelName}&version=${versionName}&year=${modelYear}&enganche=${enganche}&plazo=${term}&mensualidad=${pagoMensual}`"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
            <!-- <div v-else-if="appEnv === 'local'" class="mt-10">
                <button class="hyundai-button mx-auto" @click="sendBbvaData()">Enviar datos</button>
            </div> -->
            <iframe
                v-else
                class="iframe-cetelem"
                :src="`https://test.hyundaimotormex-leads.com/${isIframe ? 'f1' : 'f2'}/simulador_bbva/?dealer_code=${subsidiary}&modelo=${modelName}&version=${versionName}&year=${modelYear}&enganche=${enganche}&plazo=${term}&mensualidad=${pagoMensual}`"
                width="100%"
                scrolling="no"
                style="border: 0"
            ></iframe>
        </div>
        <div v-show="showLoader" class="text-center">
            <div class="lds-dual-ring mx-auto mt-40"></div>
            <p class="text-light-blue">Cargando...</p>
        </div>
        <div v-show="showSuccessMessage" class="mt-20">
            <p class="md:w-6/12 mx-auto">
                Muchas gracias por compartirnos tus datos, a la brevedad llegará a tu correo electrónico la Tabla de
                Amortización. También podrás descargarla haciendo clic en el siguiente botón:
            </p>
            <a :href="urlPDF" class="hyundai-button mx-auto mt-10" download>Descargar Tabla de Amortización</a>
        </div>
    </section>
</template>

<script>
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import "iframe-resizer/js/iframeResizer.js";

export default {
    props: [
        "showBbvaForm",
        "subsidiary",
        "subName",
        "modelName",
        "versionId",
        "versionName",
        "versionPrice",
        "modelYear",
        "term",
        "pagoMensual",
        "montoTotal",
        "totalPagar",
        "enganche",
        "seguro",
        "appEnv",
        "isIframe",
        "bbvaAppId",
    ],
    data() {
        return {
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para determinar si mostrar u ocultar el iframe
            showIframe: true,
            // Variable para determinar si mostrar u ocultar el
            // mensaje de éxito al usuario
            showSuccessMessage: false,
            // Variable para determinar si mostrar u ocultar el loader
            showLoader: false,
            // Variable para almacenar la URL del PDF que se genere
            urlPDF: "",
            // Variable para poder usar una instancia de jsPDF
            // para generar el PDF
            docPdf: new jsPDF({
                format: "letter",
            }),
            // Variable para almacenar la respuesta del iframe
            iframeMessage: {},
            // Variable para almacenar la cotización de BBVA
            bbvaQuotation: {},
            // Variable para almacenar el folio de la cotización de BBVA
            quotFolio: "",
        };
    },
    methods: {
        // Función para darle formato a los precios
        formatPrice(price) {
            return (
                "$" +
                parseFloat(price)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            );
        },
        // Función para mostrar alertas de error
        swalError() {
            Swal.fire({
                icon: "error",
                title: '<h3 class="text-2xl leading-tight font-medium">Hubo un problema al procesar tu solicitud</h3>',
                html: "<p>Intentalo de nuevo más tarde</p>",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
                didClose: () => {
                    this.$emit("back-to-simulator");
                },
            });
        },
        // Función para enviar la información necesaria a BBVA
        // para obtener los datos de la cotización y generar
        // la tabla de amortización
        sendBbvaData() {
            this.showIframe = false;
            this.showLoader = true;
            // Axios para calcular la cotización correspondiente
            axios
                .post(`${this.url}/bbva/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    enganche: this.enganche,
                    year: this.modelYear,
                    plan_term: this.term,
                    seguro: this.seguro === "insu" ? true : false,
                })
                .then((resp) => {
                    console.log("/bbva/calcular-cotizacion form-resp", resp);
                    if (resp.data.success) {
                        this.bbvaQuotation = resp.data.data;
                        this.bbvaQuotation.bbva_quotation_id = resp.data.bbva_quotation_id;

                        dataLayer.push({
                            event: "cotizacion_bbva",
                            id_cotizacion: this.iframeMessage.id,
                            plazo: this.term + " meses",
                            pago_mensual: parseFloat(this.pagoMensual), // número
                            financiamiento: parseFloat(this.montoTotal), // número
                            total_pagar: parseFloat(this.totalPagar), // número
                            modelo: this.modelName,
                            version: this.versionName,
                            year_model: this.modelYear,
                            interes_compra: this.iframeMessage.data.intencion_de_compra,
                            distribuidor: this.subName,
                        });

                        // Axios para enlazar la cotización en BD
                        // y generar el PDF de la tabla de amortización
                        axios
                            .post(`${this.url}/cotizadores/enlazar-cotizacion`, {
                                aplics_form_id: this.iframeMessage.id,
                                from_cetelem: 0,
                                casualtyInsurance: this.seguro === "insu" ? true : false,
                                downPayment: this.enganche,
                                number: this.term,
                                year: this.modelYear,
                                marketValue: this.versionPrice,
                                vehicle_id: this.versionId,
                                bbva_api_call_id: this.bbvaQuotation.bbva_quotation_id,
                                bbva_app_id: this.bbvaAppId,
                            })
                            .then((resp) => {
                                console.log("/cotizadores/enlazar-cotizacion form-resp", resp);
                                if (resp.data.success) {
                                    this.quotFolio = resp.data.bbva_folio;
                                    this.createPDF();
                                } else {
                                    this.swalError();
                                }
                            })
                            .catch((error) => {
                                if (error.response) {
                                    // Request made and server responded
                                    console.log("error.response", error.response.data);
                                } else if (error.request) {
                                    // The request was made but no response was received
                                    console.log("error.request", error.request);
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log("error.message", error.message);
                                }
                                this.swalError();
                            });
                    } else {
                        this.swalError();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                    this.swalError();
                });
        },
        // Función para generar el PDF de la tabla de amortización
        createPDF() {
            let pageWidth = this.docPdf.internal.pageSize.getWidth();
            this.docPdf.text("Tabla de Amortización BBVA Consumer Finance", pageWidth / 2, 20, { align: "center" });
            this.docPdf.text("FECHA DE EMISIÓN: " + moment().format("DD/MM/YYYY"), pageWidth / 2, 30, {
                align: "center",
            });
            this.docPdf.text(this.modelName + " " + this.versionName, pageWidth / 2, 40, { align: "center" });

            this.docPdf.setFontSize(13);
            this.docPdf.text("Monto del Préstamo: " + this.formatPrice(this.requestedAmount), 20, 60);
            this.docPdf.text("Enganche: " + this.formatPrice(this.enganche), 120, 60);
            this.docPdf.line(15, 65, 200, 65, "F");

            this.docPdf.text("Plazo: " + this.term, 20, 75);
            this.docPdf.text("Comisión de Apertura (4): " + this.formatPrice(this.openFee), 120, 75);

            this.docPdf.text("Pago Mensual (1): " + this.formatPrice(this.installmentAmount), 20, 85);
            this.docPdf.text("Seguro de Auto: " + this.formatPrice(this.casualtyInsurance), 120, 85);

            this.docPdf.text("Tasa de Interés (2): " + this.nominalFeePercentage + "%", 20, 95);
            this.docPdf.text("Seguro de Vida: " + this.formatPrice(this.lifeInsurance), 120, 95);

            this.docPdf.text("CAT (3): " + this.annualPercentageRate + "%", 20, 105);
            this.docPdf.text("Monto Total a Pagar: " + this.formatPrice(this.totalAmount), 120, 105);

            this.docPdf.setFontSize(12);
            this.docPdf.text("1 Pago mensual sin IVA.", 20, 125);

            this.docPdf.text("2", 20, 130);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text("Tasa Fija de Interés Anual.", 24, 130);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`3`, 20, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`CAT ${this.annualPercentageRate}%`, 24, 135);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`"Sin IVA" informativo.`, 48, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`Fecha de cálculo: `, 90, 135);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`${moment().format("DD/MM/YYYY")}.`, 127, 135);

            this.docPdf.setFont(undefined, "bold");
            this.docPdf.text(`Vigencia de la oferta: `, 20, 140);

            this.docPdf.setFont(undefined, "normal");
            this.docPdf.text(`${moment().format("DD/MM/YYYY")}.`, 64, 140);

            this.docPdf.text(
                "4 Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio).",
                20,
                145,
            );
            this.docPdf.text("Aplican Restricciones.", 20, 150);
            this.docPdf.text("Las cantidades presentadas en esta tabla se encuentran en pesos méxicanos.", 20, 155);

            if (this.seguro === "noInsu") {
                this.docPdf.text(
                    "La Tabla de Amortización no considera el seguro de daños, este deberá cotizarse y",
                    20,
                    165,
                );
                this.docPdf.text("dependiendo de la forma de pago, podrá modificar los datos aquí asentados.", 20, 170);
            }
            this.docPdf.text(
                "Este documento es para efectos informativos y no constituye obligación y ofrecimiento",
                20,
                175,
            );
            this.docPdf.text("formal por parte de BBVA Bancomer, S.A. en el otorgamiento del Crédito.", 20, 180);
            this.docPdf.text("Las condiciones de los Créditos estarán sujetas a cambios sin previo aviso.", 20, 185);

            this.docPdf.autoTable({
                startY: 200,
                // margin: { top: 180 },
                // pageBreak: 'auto',
                head: [
                    [
                        "Núm. Periodo",
                        "Saldo Insoluto Auto",
                        "Prima Seguro Daños con IVA",
                        "Prima Seguro Vida con IVA",
                        "Pago Mensual Capital Auto",
                        "Pago Mensual Intereses Auto",
                        "IVA Intereses Auto",
                        "Pago Total con IVA",
                    ],
                ],
                body: this.tableRows,
                // didDrawCell: (HookData) => {
                //     tableHeight += HookData.row.height
                // }
            });

            var blob = this.docPdf.output("blob");
            var formData = new FormData();

            let fileName = `Tabla de amortización BBVA - ${this.quotFolio}.pdf`;

            formData.append("pdf", blob);
            formData.append("file_name", fileName);

            // Se hace el envio del archivo para
            // poderlo guardar dentro del servidor
            axios
                .post(`${this.url}/bbva/save-pdf`, formData)
                .then((resp) => {
                    console.log("/bbva/save-pdf", resp);
                    this.urlPDF = this.url + "/storage/bbva/" + fileName;
                    this.showLoader = false;
                    this.showSuccessMessage = true;
                })
                .catch((error) => {
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                    this.swalError();
                });
        },
        // downloadQuotation() {
        //     this.docPdf.save(this.iframeMessage.id + '.pdf')
        // },
    },
    computed: {
        // Variables computadas para extraer los datos necesarios
        // para la tabla de amortización
        requestedAmount() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].requestedAmount.amount : 0;
        },
        totalAmount() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].totalAmount.amount : 0;
        },
        openFee() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].fees.itemizeFees[0].feeAmount.amount
                : 0;
        },
        installmentAmount() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].installmentPlan.installmentAmount.amount
                : 0;
        },
        casualtyInsurance() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].additionalProducts[0].amount
                : 0;
        },
        nominalFeePercentage() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].rates[0].unit.percentage : 0;
        },
        annualPercentageRate() {
            return this.bbvaQuotation.installments ? this.bbvaQuotation.installments[0].rates[1].unit.percentage : 0;
        },
        lifeInsurance() {
            return this.bbvaQuotation.installments
                ? this.bbvaQuotation.installments[0].additionalProducts[1].amount
                : 0;
        },
        // Variable computada para almacenar los datos necesarios
        // para cada fila de la tabla de amortización
        tableRows() {
            let tableRows = [];
            if (this.bbvaQuotation.installments) {
                this.bbvaQuotation.installments[0].installmentPlan.scheduledPayments.forEach((payment) => {
                    tableRows.push([
                        payment.number,
                        this.formatPrice(payment.remaining.principal.amount),
                        this.formatPrice(payment.remaining.additionalData[0].amount),
                        this.formatPrice(payment.remaining.additionalData[1].amount),
                        this.formatPrice(payment.principal.amount),
                        this.formatPrice(payment.interest.amount),
                        this.formatPrice(payment.tax.amount),
                        this.formatPrice(payment.total.amount),
                    ]);
                });
            }
            return tableRows;
        },
    },
    mounted() {
        // Función para activar el iFrameResize
        // para mostrar correctamente el iframe del formulario
        iFrameResize({
            log: false, // Enable console logging
            enablePublicMethods: true, // Enable methods within iframe hosted page
        });

        // Función para escuchar los eventos del iframe
        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent("on" + eventName, eventHandler);
            }
        }

        // Función para escuchar los mensajes emitidos por
        // el iframe en el sitio independiente
        bindEvent(window, "message", (e) => {
            // Si el mensaje contiene un id y se debe mostrar el formulario
            // se hace un scroll al inicio de la página y se ejecuta la
            // función sendBbvaData() para obtener los datos para
            // generar la tabla de amortización
            if (e.data.id != undefined && this.showBbvaForm) {
                this.$nextTick(function () {
                    let reqTop = document.getElementById("bbva-form").getBoundingClientRect().top;
                    $("html, body").animate(
                        {
                            scrollTop: reqTop + $(window).scrollTop() - 20,
                        },
                        1000,
                    );
                });
                console.log("iframe message bbva", e.data);
                this.iframeMessage = e.data;
                this.sendBbvaData();
                console.log("Datos de formulario enviados");
            }
            // else {
            //     Swal.fire({
            //         icon: 'error',
            //         title: '<h3 class="text-2xl leading-tight font-medium">Hubo un problema al procesar tu solicitud</h3>',
            //         html: '<p>Intentalo de nuevo más tarde</p>',
            //         confirmButtonText: 'Aceptar',
            //         customClass: {
            //             confirmButton: 'text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2',
            //         },
            //         buttonsStyling: false
            //     })
            // }
        });
    },
};
</script>

<style></style>
